import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { TypographyHeading, TypographyBody, Skeleton } from '@honeycomb/ui-core';
import { pluraliseCount } from '../../utils/pluraliseCount';
import { interjectResourceString } from '../../utils/interjectResourceString';
export function FlightSearchResultsHeading({ filteredFlightCount, loading = false, hideSubHeading = false, }) {
    const { resourceStrings: { FLIGHTS_SRP_TITLE, FLIGHTS_SRP_TITLE_SINGULAR, FLIGHTS_SRP_TITLE_LOADING, FLIGHTS_PAGE_SUBTITLE, }, } = useGlobalContext();
    const formattedTitle = pluraliseCount(filteredFlightCount, {
        singular: FLIGHTS_SRP_TITLE_SINGULAR,
        plural: interjectResourceString(FLIGHTS_SRP_TITLE, filteredFlightCount),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(TypographyHeading, { component: "h1" }, loading ? FLIGHTS_SRP_TITLE_LOADING : formattedTitle),
        !hideSubHeading && (React.createElement(TypographyBody, { component: "div", size: "s", mt: 2 }, loading ? React.createElement(Skeleton, { variant: "text", w: 320 }) : FLIGHTS_PAGE_SUBTITLE))));
}
